module.exports = __webpack_public_path__ + "media/output360.8cb23414.mp4";